import React from 'react';
import styled from 'styled-components';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 30px;
`;

const Th = styled.th`
  background-color: #f2f2f2;
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ccc;
`;

const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #ddd;
`;

const NoUsers = styled.p`
  margin-top: 20px;
  font-style: italic;
  color: #666;
`;

const ActionButton = styled.button`
  margin-right: 10px;
  padding: 6px 12px;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: white;
  background-color: ${({ variant }) =>
    variant === 'edit' ? '#17a2b8' : '#dc3545'};

  &:hover {
    opacity: 0.85;
  }
`;

const Select = styled.select`
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 14px;
`;

const UserTable = ({ users, onEditUser, onDeleteUser, onRoleUpdated }) => { //show pending new tab
  if (users.length == 0) {
    return <NoUsers>No users added yet.</NoUsers>;
  }



  const rejected = async (email) => {
    try {
      const res = await fetch('/api/reject_request', { //update_user_role
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, status: 'pending' }),
      });

      const data = await res.json();
      if (res.ok) {
        console.log(`Role updated: ${email} , status: pending`); //status: active new

      }
    } catch (err) {
      console.error('Error updating role:', err);
    }
  };

  const accepted = async (email) => {
    try {
      const res = await fetch('/api/accept_request', { //update_user_role
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, status: 'active' }),
      });

      const data = await res.json();
      if (res.ok) {
        console.log(`Role updated: ${email} , status: active`); //status: active new

      }
    } catch (err) {
      console.error('Error updating role:', err);
    }
  };


  return (
    <Table>
      <thead>
        <tr>
          <Th>Email</Th>
          <Th>Role</Th>
          <Th>Actions</Th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <tr key={user.email}>
            <Td>{user.email}</Td>
            <Td>
              {
                user.role
              }
            </Td>
            <Td>
              {user.status === "pending" ? (
                <>
                  <ActionButton variant="edit" onClick={() => { accepted(user.email); onEditUser(user); }}>
                    Accept
                  </ActionButton>
                  <ActionButton
                    variant="delete"
                    onClick={() => {
                      rejected(user.email);
                      onDeleteUser(user.email);
                    }}
                  >
                    Reject
                  </ActionButton>
                </>
              ) : (
                <>
                  <ActionButton variant="edit" onClick={() => onEditUser(user)}>
                    Edit
                  </ActionButton>
                  <ActionButton variant="delete" onClick={() => onDeleteUser(user.email)}>
                    Delete
                  </ActionButton>
                </>
              )}
            </Td>
          </tr>
        ))}
      </tbody>
    </Table>

  );
};

export default UserTable;
